import 'stylesheets/components/navigation.scss';
import 'stylesheets/global.scss';

import React, {Component}   from 'react';
import { Link, IndexLink }  from 'react-router';
import PureRenderMixin      from 'react-addons-pure-render-mixin';
import { connect }          from 'react-redux';
import $                    from 'jquery';
import { FormattedMessage } from 'react-intl';
import {isAllowed}          from 'modules/profile/selectors';
import { store }            from 'app/store';
import * as actionCreators  from 'modules/profile/actions';
import { Icon }             from 'routes/app/components';


export class Navigation extends Component {

    static propTypes = {
        profile: React.PropTypes.object.isRequired,
        isAllowed: React.PropTypes.func.isRequired/*,
        fetchProfile: React.PropTypes.func.isRequired*/
    };

    componentDidMount() {
        //$(this.refs.settings).dropdown();

        //this.props.fetchProfile();
        $(this.refs.sideMenuTrigger).sideNav({
            closeOnClick: true
        });

        $('header .collapsible').collapsible({
            accordion: true
        });
    }

    settingsLink(text=<i className="material-icons right"><FormattedMessage id="nav.settings" /></i>) {
        return <li className=""><Link to="/settings" activeClassName="active">{text}</Link></li>;
    }

    logoutLink() {
        return <li><Link to="/logout"><FormattedMessage id="nav.logout" /></Link></li>;
    }

    render() {
        let {profile, isAllowed, ...props} = this.props;

        return (
            <header>
                <div>
                    <a href="#" data-activates="mobile" ref="sideMenuTrigger"
                       className="button-collapse top-nav hide-on-large-only">
                        <i className="material-icons">menu</i>
                    </a>
                </div>
                <ul id="mobile" className="side-nav fixed" >
                    <li className="logo">
                        <IndexLink to="/" >
                            <span>
                                <span className="logo__company">{profile.companyName}</span>
                                <span className="logo__app"><FormattedMessage id="nav.appName" /></span>
                            </span>
                        </IndexLink>
                    </li>

                    {(isAllowed(91100) || isAllowed(91130)) &&
                    <li className="no-padding">
                        <ul className="collapsible collapsible-accordion">
                            <li className="active">
                                <a className="collapsible-header active"><FormattedMessage id="nav.visits" /></a>
                                <div className="collapsible-body" >
                                    <ul>
                                        {isAllowed(91130) && <li><Link to="/visits/new" activeClassName="active"><FormattedMessage id="nav.visits.announce" /></Link></li>}
                                        {isAllowed(91100) && <li><Link to="/visits" activeClassName="active"><FormattedMessage id="nav.visits.overview" /></Link></li>}
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </li>
                    }

                    {isAllowed(91900) &&
                    <li className=""><Link to="/dashboard" activeClassName="active"><FormattedMessage id="nav.dashboard" /></Link></li>
                    }

                    <li className="no-padding">
                        <ul className="collapsible collapsible-accordion">
                            <li className="active">
                                <a className="collapsible-header active">
                                    <span className="side-nav__block">
                                        <span className="side-nav__sup">{profile.requestingCompany}</span>
                                        <span>{profile.fullName}</span>
                                    </span>
                                </a>
                                <div className="collapsible-body" >
                                    <ul>
                                        {isAllowed(91010) && this.settingsLink(<FormattedMessage id="nav.settings" />)}
                                        {this.logoutLink()}
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </li>


                </ul>
            </header>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.get('profile').toJS(),
        isAllowed: isAllowed(state)
    };
}

export const NavigationContainer = connect(mapStateToProps, actionCreators)(Navigation);
